<div #sidebarScrollContent class="d-flex flex-column p-6 payments-sidebar-scroll-content">
  <div *ngIf="isPaymentProcessing$ | async" class="payment-processing-overlay"></div>

  <div class="d-flex align-items-center">
    <button *ngIf="isSidebarPopover$ | async" andButton color="ghost" size="small" class="me-2" (click)="openedChange.emit(false)">
      <aiwyn-icon name="x"></aiwyn-icon>
    </button>
    <h1>Make a payment</h1>
  </div>

  <mat-radio-group
    [value]="payWithInvoices$ | async"
    (change)="setPayWithInvoices($event)"
    class="d-flex align-items-center mt-6"
  >
    <mat-radio-button
      *ngIf="{ value: (payablesExist$ | async) === false } as noPayablesExist"
      [value]="true"
      [disabled]="noPayablesExist.value"
      tooltip="You don’t have any unpaid invoices."
      [tooltipEnabled]="noPayablesExist.value"
      class="me-4 fw--500"
      data-cy="pay-with-invoice"
    >
      Pay invoice(s)
    </mat-radio-button>

    <mat-radio-button [value]="false" data-cy="pay-without-invoice">Pay without invoice</mat-radio-button>
  </mat-radio-group>

  <ng-container *ngIf="payWithInvoices$ | async; else payWithoutInvoicesTemplate">
    <ng-container *ngIf="{ value: selectedPayablesCount$ | async } as selectedPayablesCount">
      <ng-container *ngIf="selectedPayablesCount.value === 0">
        <div
          *ngIf="{ value: isSelectedPayablesValid$ | async } as isSelectedPayablesValid"
          class="alert mt-6 text-start"
          [ngClass]="{ 'alert--info': isSelectedPayablesValid.value, 'alert--error': isSelectedPayablesValid.value === false }"
        >
          Select one or multiple invoices on the left to pay for them.
        </div>
      </ng-container>

      <app-client-payment-summary
        *ngFor="let clientPaymentSummary of clientPaymentSummaries$ | async; trackBy : trackByClientId"
        [paymentSummary]="clientPaymentSummary"
        [currency]="activeCurrency$ | async"
        (invoicesRemoved)="removeSelectedClientInvoices($event)"
        (prepaymentsRemoved)="removeSelectedClientPrepayments($event)"
        (payLateFeeChange)="payClientLateFees($event)"
        (creditAppliedChange)="applyCredits($event)"
        (addOnRemoved)="removeAddOn($event)"
      ></app-client-payment-summary>
    </ng-container>

    <ng-container *ngIf="(isActiveCurrencyUsd$ | async) && (addOnOptions$ | async) as addOnOptions">
      <app-add-add-on
        *ngIf="addOnOptions.status !== LoadableStatus.LOADED || addOnOptions.data?.length > 0"
        [addOnOptions]="addOnOptions$ | async"
        (added)="addAddOn($event)"
        class="mt-6"
      ></app-add-add-on>
    </ng-container>
  </ng-container>

  <ng-template #payWithoutInvoicesTemplate>
    <app-pay-without-invoice-form
      [payWithoutInvoicePayable]="payWithoutInvoicePayable$ | async"
      [jobs]="jobsLoadable$ | async"
      [clients]="clientsLoadable$ | async"
      [paymentTypes]="addOnOptions$ | async"
      class="mt-6"
      (payWithoutInvoicePayableChange)="onPayWithoutInvoicePayableChange($event)"
    ></app-pay-without-invoice-form>
  </ng-template>

  <!--
    Email-first checkout (flag: enable_require_email_address_before_payment_method). When on, email + methods
    are grouped under a single "Payment Information" section, email precedes the methods, and the methods stay
    locked until a valid email is entered. When off, the legacy ordering (methods above, email below) is
    preserved.
  -->
  @if (isRequireEmailBeforePaymentEnabled$ | async) {
    <h4 class="mt-6 mb-2" dataSelector="payment-information-header">Payment Information</h4>

    <app-recipient-emails
      [primaryEmail]="primaryRecipientEmail$ | async"
      [additionalEmails]="additionalRecipientEmails$ | async"
      (primaryEmailChanged)="onPrimaryEmailChanged($event)"
      (additionalEmailsChanged)="onAdditionalEmailsChanged($event)"
      (isValid)="onEmailValidChanged($event)"
      (primaryEmailPrepopulated)="onPrimaryEmailPrepopulated($event)"
    >
      @if (isPaymentMethodRequired$ | async) {
        <app-select-payment-method
          class="d-block mt-4"
          [showHeader]="false"
          [emailGateActive]="true"
          [emailGateLocked]="!emailValid()"
          [emailGatePrepopulated]="emailGatePrepopulated()"
          [intent]="PaymentMethodIntent.PAYMENT"
          [paymentFlow]="PaymentFlow.STANDARD"
          [paymentMethodMode]="paymentMethodMode$ | async"
          [canSetDefaultPaymentMethodMode]="true"
          [selectedPaymentMethodId]="selectedPaymentMethodId$ | async"
          [surface]="paymentMethodSurface"
          (paymentMethodModeChange)="onPaymentMethodModeChange($event)"
          (paymentMethodSelected)="onPaymentMethodSelected($event)"
          (lockedNewMethodAttempt)="onLockedPaymentMethodClick()"
        ></app-select-payment-method>
      } @else {
        <ng-container [ngTemplateOutlet]="noPaymentMethodRequiredTemplate"></ng-container>
      }
    </app-recipient-emails>
  } @else {
    <app-select-payment-method
      *ngIf="isPaymentMethodRequired$ | async; else noPaymentMethodRequiredTemplate"
      [intent]="PaymentMethodIntent.PAYMENT"
      [paymentFlow]="PaymentFlow.STANDARD"
      [paymentMethodMode]="paymentMethodMode$ | async"
      [canSetDefaultPaymentMethodMode]="true"
      [selectedPaymentMethodId]="selectedPaymentMethodId$ | async"
      [surface]="paymentMethodSurface"
      class="mt-6"
      (paymentMethodModeChange)="onPaymentMethodModeChange($event)"
      (paymentMethodSelected)="onPaymentMethodSelected($event)"
    ></app-select-payment-method>

    <app-recipient-emails
      [primaryEmail]="primaryRecipientEmail$ | async"
      [additionalEmails]="additionalRecipientEmails$ | async"
      class="mt-4"
      (primaryEmailChanged)="onPrimaryEmailChanged($event)"
      (additionalEmailsChanged)="onAdditionalEmailsChanged($event)"
    ></app-recipient-emails>
  }

  <ng-template #noPaymentMethodRequiredTemplate>
    <div class="alert alert--info mt-6">
      No payment method is required. Credits applied will cover the entire balance, and you will not be charged for this transaction.
    </div>
  </ng-template>
</div>

<!-- Footer -->
<div
  class="d-flex flex-column p-6 payments-sidebar-footer"
  [ngClass]="{ 'indicate-scrollable-content-above': showFooterBoxShadow$ | async }"
>
  <app-payment-summary
    [isCustomProcessingFeeEnabled]="configService.adminCanEditCcProcessingFee"
    [forceZeroState]="doAppliedCreditsCoverSubtotal$ | async"
    [areLateFeesByClient]="areLateFeesByClient$ | async"
    [ignoreLateFees]="shouldIgnoreLateFees$ | async"
    [disableLateFeesMessage]="disableLateFeesMessage$ | async"
    [lateFeeTooltipMessage]="lateFeeTooltipMessage$ | async"
    [currency]="activeCurrency$ | async"
  ></app-payment-summary>

  <mat-checkbox *ngIf="!authAdaptor.isContactOrAdmin" [formControl]="termsCheckboxControl" class="mt-4" data-cy="terms-and-conditions">
    Agree to Aiwyn's <a [href]="configService.paymentTermsOfServiceURL" target="_blank">Terms of Service</a>
    and <a href="https://www.aiwyn.ai/privacy-policy" target="_blank">Privacy Policy</a>
  </mat-checkbox>

  <button
    andButton
    color="primary"
    size="large"
    [disabled]="shouldDisablePay$ | async"
    [isLoading]="isPaymentProcessing$ | async"
    class="mt-4"
    (click)="onPayNow()"
    data-cy="pay-now"
  >
    <aiwyn-icon name="lock" class="me-2"></aiwyn-icon>
    Pay {{ total$ | async | currency: (activeCurrency$ | async).code }}
  </button>

  <button
    *ngIf="!isReviewAndPayPage && payWithInvoices$ | async"
    andButton
    color="secondary"
    size="large"
    class="mt-4"
    [disabled]="(selectedPayablesCount$ | async) === 0"
    (click)="onReviewInvoices()"
    data-cy="review-and-pay"
  >
    Review Invoices
  </button>
</div>
